import React from 'react'
import AboutImg from '../assets/about-img.jpeg';
import AboutImg1 from '../assets/about-img1.jpeg';
import AboutImg2 from '../assets/about-img2.jpeg';
import { useNavigate } from 'react-router-dom';


const AboutMe = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* about section */}
      <section className='py-5 bg-light'>
        <div className='container px-lg-5 px-4'>

          <div className='row'>

            <div className='col-lg-5 col-12 my-2'>
              <img src={AboutImg} className='img-fluid' alt='about' />
            </div>

            <div className='col-lg-7 col-12 my-2 my-2'>
              <div className='about-content px-lg-5 py-lg-5 px-3 py-3'>
                <p className='sec-subheading'>About Us</p>
                <p className='sec-heading'>We Provide Best Tour Packages In Your Budget</p>
                <p className='text-muted'>Omanshi Travels offers a wide range of tours and travel services, ensuring a memorable and hassle-free
                  experience for the tourists. Specializing in customized travel packages, group tours, adventure trips, and corporate travel, we
                  prioritize customer satisfaction. Our travel guides helps tourists explore new destinations with ease, comfort, and
                  professionalism.</p>

                <div className='row my-3'>
                  <img src={AboutImg1} className='img-fluid col-6' alt='about' />
                  <img src={AboutImg2} className='img-fluid col-6' alt='about' />
                </div>
                {/* inner row ends */}
                <button className='slider-btn px-3 py-2' onClick={() => navigate('/tour-booking')}>Book Now</button>

              </div>
            </div>
            {/* about right ends */}

          </div>
          {/* row ends */}


          <div className='row mt-4'>

            <div className='col-lg-4 col-md-6 col-12 my-2 d-flex'>

              <i class="fa-solid about-icon fa-tags"></i>
              <div>
                <p className='fs-5 fw-semibold my-0'>Reasonable Prices</p>
                <p className='text-muted my-0'>Affordable travel options without compromising quality or comfort.</p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2 d-flex'>
              <i class="fa-solid about-icon fa-star"></i>
              <div>
                <p className='fs-5 fw-semibold my-0'>Best Services</p>
                <p className='text-muted my-0'>Offering reliable services customized to meet your needs with excellence.</p>
              </div>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-2 d-flex'>
              <i class="fa-solid about-icon fa-globe"></i>
              <div>
                <p className='fs-5 fw-semibold my-0'>National Coverage</p>
                <p className='text-muted my-0'>Providing nationwide coverage, ensuring services across the country.</p>
              </div>
            </div>

          </div>
          {/* row ends */}


        </div>
      </section>
      {/* about section ends */}
    </>
  )
}

export default AboutMe
